import {Controller} from 'stimulus'

export default class extends Controller {
  connect () {
    const {dataset} = this.element

    this.url = dataset.refreshUrl
    this.interval = parseInt(dataset.refreshInterval || '10000', 10)

    if (!this.url) {
      console.error('refresh controller: data-refresh-url is required')
      return
    }

    // Only start polling if there's a disabled button (job is running)
    if (this.element.querySelector('button[disabled]')) {
      this.scheduleRefresh()
    }
  }

  disconnect () {
    this.stopPolling()
  }

  scheduleRefresh () {
    this.timer = setTimeout(() => this.refresh(), this.interval)
  }

  stopPolling () {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  async refresh () {
    try {
      const response = await fetch(this.url)

      if (!response.ok) {
        console.error('refresh controller: fetch failed', response.status)
        this.scheduleRefresh() // Schedule next refresh even on error
        return
      }

      const html = await response.text()
      this.element.innerHTML = html

      // Continue polling only if there's still a disabled button
      if (this.element.querySelector('button[disabled]')) {
        this.scheduleRefresh()
      }
    } catch (error) {
      console.error('refresh controller: error fetching content', error)
      this.scheduleRefresh() // Schedule next refresh even on error
    }
  }
}
